import MarkdownRender from 'components/Luxkit/MarkdownRender'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import React, { useMemo } from 'react'
import { isHotelPackage } from 'lib/offer/offerTypes'
import AccommodationAmenitiesList, { extractBedbankRoomPackageAmenityGroups, extractHotelRoomPackageAmenityGroups, RoomPackageAmenityGroup } from './AccommodationAmenitiesList'

interface RoomPackageDetails {
  amenityGroups: Array<RoomPackageAmenityGroup>;
  policyDescription?: string;
}

function extractHotelRoomPackageAmenitiesAndPoliciesDetails(roomPackage: App.HotelPackage):RoomPackageDetails {
  return {
    amenityGroups: extractHotelRoomPackageAmenityGroups(roomPackage),
    policyDescription: roomPackage.roomPolicyDescription,
  }
}

function extractBedbankRoomPackageAmenitiesAndPoliciesDetails(roomPackage: App.BedbankPackage):RoomPackageDetails {
  return {
    amenityGroups: extractBedbankRoomPackageAmenityGroups(roomPackage),
    policyDescription: undefined,
  }
}

interface Props {
  roomPackage: App.HotelPackage | App.BedbankPackage
}

function AccommodationAmenitiesAndPoliciesContent(props: Props) {
  const { roomPackage } = props
  const details = useMemo(() => {
    if (isHotelPackage(roomPackage)) {
      return extractHotelRoomPackageAmenitiesAndPoliciesDetails(roomPackage)
    } else {
      return extractBedbankRoomPackageAmenitiesAndPoliciesDetails(roomPackage)
    }
  }, [roomPackage])

  return <>
    {!!details.amenityGroups.length && <Group direction="vertical" gap={12}>
      <Heading variant="heading6">Room Amenities</Heading>
      <AccommodationAmenitiesList amenities={details.amenityGroups} />
    </Group>}
    {details.policyDescription && <Group direction="vertical" gap={12}>
      <Heading variant="heading6">Room Policies</Heading>
      <MarkdownRender content={details.policyDescription} type="compact" />
    </Group>}
  </>
}

export default AccommodationAmenitiesAndPoliciesContent
